
<h2>Dispersiones Parciales</h2>
<dx-data-grid [dataSource]="dispersionsPending" keyExpr="id" [showBorders]="true" [masterDetail]="{ enabled: true, template: 'detail', autoExpandAll: false }">
  <dxo-load-panel [enabled]="true"></dxo-load-panel>
  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true"></dxo-pager>
  <!--
  <dxi-column dataField="dateCreated" caption="Creada" cellTemplate="dateTemplate" alignment="center"></dxi-column>-->
  <!--<dxi-column dataField="dateScheduled" caption="Fecha programada" cellTemplate="dateTemplate" alignment="center"></dxi-column>-->
  <!--<dxi-column dataField="programName" caption="Programa"></dxi-column>-->
  <!--<dxi-column dataField="dispersionTypeName" caption="Tipo"></dxi-column>-->
  <dxi-column dataField="beneficiarie.employeeName" caption="Nombre"></dxi-column>
  <dxi-column dataField="beneficiarie.employeeLastName" caption="Apellido P."></dxi-column>
  <dxi-column dataField="beneficiarie.employeeSecondLastName" caption="Apellido M."></dxi-column>
  <dxi-column dataField="company.companyName" caption="Empresa"></dxi-column>
  <dxi-column dataField="amount" caption="Monto Total" dataType="number" format="currency"
      alignment="center">
      <dxo-format type="currency" [precision]="2"></dxo-format>
  </dxi-column>
  <dxi-column dataField="amountSended" caption="Monto Dispersado" dataType="number" format="currency"
      alignment="center">
      <dxo-format type="currency" [precision]="2"></dxo-format>
  </dxi-column>
  <dxi-column dataField="amountPending" caption="Monto Por Dispersar" dataType="number" format="currency"
      alignment="center">
      <dxo-format type="currency" [precision]="2"></dxo-format>
  </dxi-column>
  
  <!-- Dispersion Details -->
  <div *dxTemplate="let d of 'detail'">
      <div class="flex flex-nowrap flex-space-between datagrid-detailsW">
          <div class="mr-5 ml-5">
                
              <h2>Detalle</h2>
              <ul>
                <li>ID: {{ d.data.id}}</li>
              </ul>
              <h2>Dispersiones</h2>
              <div>
                <table>
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th class="text-right">Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let fondeo of d.data.dispersions">
                      <tr>
                        <td>{{ fondeo.dateCreated }}</td>
                        <td class="text-right pl-5">{{ fondeo.amount | currency }}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
          </div>
          <div class="mr-5 ml-5">
              <h2>Dispersión Origen</h2>
              <ul>
                
                <li>ID: {{ d.data.dispersionOrigin.id }}</li>
                <li>Empresa: {{ d.data.dispersionOrigin.companyName }}</li>
                <li>Programa: {{ d.data.dispersionOrigin.programName }}</li>
                <li>Tarjeta: **** **** **** {{ d.data.beneficiarie.cardNumberLastDigits }}</li>
                <li>Tipo: {{ d.data.dispersionOrigin.dispersionTypeName }}</li>
                <li>Fecha Registro: {{ d.data.dispersionOrigin.dateCreated }}</li>
                <li>Fecha Programada: {{ d.data.dispersionOrigin.dateScheduled }}</li>
                <li>Fecha Ejecución: {{ d.data.dispersionOrigin.dateExecuted }}</li>
              
              </ul>
          </div>
          
          <div class="mr-5 ml-5 pt-3">
              <dx-button text="Dispersar" type="default" (onClick)="selectDispersion(d.data);openPopup('dispersar')"></dx-button>
          </div>
      </div>
  </div>
</dx-data-grid>



<!-- Popup -->
<dx-popup [width]="'auto'" [height]="'auto'" [showTitle]="true" title="Ejecutar Dispersion" [dragEnabled]="false" [closeOnOutsideClick]="true" [(visible)]="popups['dispersar'].visible">
<div *dxTemplate="let data of 'content'" class="runDispersion-popup">
  <div *ngIf="dispersion">
    <!-- Form: Monto a Dispersar -->
    <dx-form [(formData)]="dispersionExecute" [colCount]="1" labelLocation="left" style="width: 100%">
      
      <dxi-item dataField="granTotal" dataType="currency" [isRequired]="false">
        <dxo-label text="Monto a Dispersar"></dxo-label>
        <dx-number-box valueChangeEvent="keyup" #amount format="$ #,##0.##" [(value)]="dispersionExecute.granTotal">
          <dx-validator>
            <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
            <dxi-validation-rule type="range" [min]="1" message="El monto debe ser al menos de $1.00"></dxi-validation-rule>
            <dxi-validation-rule type="range" [max]="maxAmountDispersion" message="El monto debe ser menor a {{maxAmountDispersion | currency}}"></dxi-validation-rule>
          </dx-validator>
        </dx-number-box>
      </dxi-item>
    </dx-form>

    <!-- Montos Dispersion -->
    <table class="w-100 my-4" style="font-size:15px">
      <tbody>
        <tr>
          <td>Tarjeta:</td>
          <td class="text-right color-ihunter-primary">**** **** **** {{ dispersion.beneficiarie.cardNumberLastDigits }}</td>
        </tr>
        <tr>
          <td>Monto Restante:</td>
          <td class="text-right color-ihunter-primary">{{ (dispersion.amountPending - dispersionExecute.granTotal) | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Buttons Popup -->
  <div class="flex felx-nowrap flex-space-between mt-4">
    <dx-button id="cancelBtn" type="warning" (onClick)="closePopup('dispersar')" text="Cancelar" class="txt-center"></dx-button>
    <dx-button id="button" type="default" (onClick)="executeDispersion()" text="Confirmar" class="txt-center"></dx-button>
  </div>

</div>
</dx-popup>